export default class ProjectPinned {
	
	static get TYPE() {
		const TYPE = {
			CLASS: 1,
			ADDTIONAL: 2,
		};
		return TYPE;
	}
	
	static get PINNED_ID_CLASS() {
		return '00000000-0000-0000-0000-000000000000';
	}
}
